import { useMutation } from '@tanstack/react-query';
import { amendCarePlan } from '../services/care_plan';

const AmendCarePlan = () => {
    const amendCarePlanMutation = useMutation({
        mutationFn: ({ carePlanId, editReason }) => amendCarePlan(carePlanId, editReason),
        onError: (error) => {
            console.error('Error amending care plan:', error);
        },
    });

    return amendCarePlanMutation;
};

export default AmendCarePlan;
